import axios from 'axios'
import { getAttributes } from '../imports'

// eslint-disable-next-line
export function fetchNews(locale) {
    // Now create the URL:
    const attributes = getAttributes(locale)
    const url = attributes.url.replace('{locale}', locale)

    // console.info('news url: ', url)

    // Do the actual fetching
    return axios.get(url).then((response) => {
        // Make sure that we received a valid response status
        // otherwise throw an error with the response status
        if (response.status !== 200) throw Error(response.status)

        // Return the news
        return response.data
    })
}



// WEBPACK FOOTER //
// ./src/features/News/data/api.js